import { render, staticRenderFns } from "./CreditRedactorForm.vue?vue&type=template&id=d35f43fa&scoped=true&"
import script from "./CreditRedactorForm.vue?vue&type=script&lang=js&"
export * from "./CreditRedactorForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d35f43fa",
  null
  
)

export default component.exports